export default {
  "cus.customizableItems": "カスタマイズ項目",
  "cus.paperTicket": "紙チケット",
  "cus.logoForPrinting": "印刷用ロゴ",
  "cus.plsInputNotice": "注意事項を入力してください",
  "cus.self-definedMessage(title)": "カスタムメッセージ（タイトル）",
  "cus.self-definedMessage(content)": "カスタムメッセージ（内容）",
  "cus.mailTicket": "メールチケット",
  "cus.logo": "ロゴ",
  "cus.imageTips": "推奨の画像サイズ：400×100ピクセル",
};